/*
 * @Autor: lmlss
 * @Date: 2024-08-26 13:19:13
 * @Description:
 * @LastEditors: lmlss
 * @LastEditTime: 2024-08-26 15:45:52
 */
import { Icon } from "antd";

export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4503892_4reji1w9h8u.js",
});
